import React, { useState } from 'react';
import { List, InputItem, Picker, Button } from 'antd-mobile';

import { Purpose } from '../utils/const';
import { CountryFilter } from '../components/CountryFilter';
import { CustomerFilter } from '../components/CommonFilter';
import ChannelFilter from '../components/ChannelFilter';

export default function Filters(props) {

  const { defaultFilters, onFilter } = props;

  const [filterValues, setFilterValues] = useState(defaultFilters);
  const [currentState, setCurrentState] = useState([])

  const onFilterChange = (fields) => {
    const values = { ...filterValues };
    Object.keys(fields).forEach(item => {
      values[item] = fields[item];
    })
    setFilterValues(values);
  };

  const onSubmit = () => {
    onFilter(filterValues)
  }
  const onReset = () => {
    setFilterValues(defaultFilters);
    setCurrentState([]);
  }

  const onChangeCountry = (v) => {
    setCurrentState(v)
    onFilterChange({ BrevityCode: v[0] })
  }

  return <form>
    <List >
      <CustomerFilter value={[filterValues.AccountId]} onChange={v => onFilterChange({ AccountId: v[0] })} />
      <CountryFilter value={currentState} onChange={onChangeCountry} allowAll />
      <Picker
        data={['HTTP', 'SMPP'].map(item => ({ label: item, value: item }))}
        title="协议类型"
        value={[filterValues.ProtoType]}
        cols={1}
        onChange={v => onFilterChange({ ProtoType: v[0] })}
      >
        <List.Item arrow="horizontal">协议类型</List.Item>
      </Picker>
      <Picker
        data={Object.keys(Purpose).map(item => ({ label: Purpose[item], value: item }))}
        title="短信类型"
        value={[filterValues.Purpose]}
        cols={1}
        onChange={v => onFilterChange({ Purpose: v[0] })}
      >
        <List.Item arrow="horizontal">短信类型</List.Item>
      </Picker>
      <InputItem value={filterValues.SmppAccount} onChange={v => onFilterChange({ SmppAccount: v })}>SMPP账号</InputItem>
      <ChannelFilter
        title="主通道"
        value={[filterValues.mainChannel]}
        onChange={val => {
          if (val && val.length > 0) {
            onFilterChange({ mainChannel: val[0] })
          }
        }}
      />
      <ChannelFilter
        title="备通道"
        value={[filterValues.prepareChannel]}
        onChange={val => {
          if (val && val.length > 0) {
            onFilterChange({ prepareChannel: val[0] })
          }
        }}
      />
      <List.Item>
        <div style={{ float: 'right' }}>
          <Button type="primary" size="small" inline onClick={onSubmit} className="mr-10">确定</Button>
          <Button size="small" inline onClick={onReset}>重置</Button>
        </div>
      </List.Item>
    </List>
  </form>
}